import { BannerWrapper } from "../../BannerWrapper";

const title = "You are viewing a read-only version of this canvas";
const description =
  "We are experiencing intended downtime. You can still view and interact with the canvas, but you won't be able to make any changes.";

export function ViewOnlyDowntimeBanner() {
  return <BannerWrapper title={title} description={description} />;
}
